import { ColourPickerV2 } from "./colour-picker-v2";

import type { PopoverController } from "../../../../utils/hooks/use-popover";
import type { ClickAwayListenerProps } from "@mui/material";
import type { FC } from "react";

export const ColourPicker: FC<{
  anchorRef: React.RefObject<HTMLElement | null>;
  popover: PopoverController;
  onChange: (color: string, skipAddingToHistoryStack?: boolean) => void;
  colour: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  onClickAway?: ClickAwayListenerProps["onClickAway"];
}> = ({ anchorRef, popover, onChange, colour, inputRef, onClickAway }) => (
  <ColourPickerV2
    anchorRef={anchorRef}
    popover={popover}
    onChange={onChange}
    colour={colour}
    inputRef={inputRef}
    onClickAway={onClickAway}
  />
);
